export const APP_NAME = 'Minha Obra'
export const APP_VERSION = '0.1.0'

export const DB_NAME = 'minha-obra-db'
export const DB_VERSION = 8

export const STORES = {
  OBRA_CONFIG: 'obra_config',
  TOPICOS_PROGRESSO: 'topicos_progresso',
  LANCAMENTOS_FINANCEIROS: 'lancamentos_financeiros',
  DOCUMENTOS: 'documentos',
  ALERTAS: 'alertas',
  DIARIO: 'diario',
} as const

export type StoreKey = keyof typeof STORES
export type StoreName = (typeof STORES)[StoreKey]

export interface Modulo {
  id: string
  slug: string
  titulo: string
  icone: string
  ordem: number
}

export const MODULOS: Modulo[] = [
  { id: 'terreno', slug: 'terreno', titulo: 'Terreno', icone: '01', ordem: 1 },
  {
    id: 'sistemas-construtivos',
    slug: 'sistemas-construtivos',
    titulo: 'Sistemas Construtivos',
    icone: '02',
    ordem: 2,
  },
  { id: 'projetos', slug: 'projetos', titulo: 'Projetos', icone: '03', ordem: 3 },
  {
    id: 'planejamento-financeiro',
    slug: 'planejamento-financeiro',
    titulo: 'Planejamento Financeiro',
    icone: '04',
    ordem: 4,
  },
  { id: 'mao-de-obra', slug: 'mao-de-obra', titulo: 'Mão de Obra', icone: '05', ordem: 5 },
  { id: 'execucao', slug: 'execucao', titulo: 'Execução', icone: '06', ordem: 6 },
  { id: 'tributos', slug: 'tributos', titulo: 'Tributos', icone: '07', ordem: 7 },
]

export interface SelectOption {
  value: string
  label: string
}

export const PADROES_CONSTRUCAO: SelectOption[] = [
  { value: 'economico', label: 'Econômico' },
  { value: 'medio', label: 'Médio' },
  { value: 'nobre', label: 'Nobre' },
  { value: 'alto', label: 'Alto' },
]

export const CATEGORIAS_FINANCEIRAS: string[] = [
  'Terreno',
  'Fundação',
  'Estrutura',
  'Alvenaria',
  'Cobertura',
  'Instalações Elétricas',
  'Instalações Hidráulicas',
  'Revestimentos',
  'Esquadrias',
  'Pintura',
  'Mão de Obra',
  'Projetos e Laudos',
  'Taxas e Documentação',
  'Equipamentos',
  'Materiais',
  'Outros',
]

export const FORMAS_PAGAMENTO: SelectOption[] = [
  { value: 'dinheiro', label: 'Dinheiro' },
  { value: 'pix', label: 'PIX' },
  { value: 'transferencia', label: 'Transferência' },
  { value: 'boleto', label: 'Boleto' },
  { value: 'cartao', label: 'Cartão' },
  { value: 'financiamento', label: 'Financiamento' },
]

export const STATUS_LANCAMENTO: SelectOption[] = [
  { value: 'previsto', label: 'Previsto' },
  { value: 'pago', label: 'Pago' },
  { value: 'pendente', label: 'Pendente' },
  { value: 'parcelado', label: 'Parcelado' },
]

export const CATEGORIAS_DOCUMENTO: string[] = [
  'Projetos',
  'Laudos',
  'Notas Fiscais',
  'Comprovantes',
  'Fotos de Obra',
  'Contratos',
  'Documentos Legais',
  'Outros',
]

export interface FaseConstrutiva {
  id: string
  label: string
  icone: string
  desc: string
}

export const FASES_CONSTRUTIVAS: FaseConstrutiva[] = [
  { id: 'pre-obra', label: 'Pré-Obra', icone: 'PO', desc: 'Aprovação, alvará e preparação' },
  { id: 'infraestrutura', label: 'Infraestrutura', icone: 'IN', desc: 'Fundação e contenção' },
  { id: 'superestrutura', label: 'Superestrutura', icone: 'SU', desc: 'Pilares, vigas e laje' },
  { id: 'vedacao', label: 'Vedação', icone: 'VE', desc: 'Alvenaria e paredes' },
  { id: 'cobertura', label: 'Cobertura', icone: 'CO', desc: 'Telhado e impermeabilização' },
  { id: 'instalacoes', label: 'Instalações', icone: 'IS', desc: 'Elétrica, hidráulica e gás' },
  {
    id: 'acabamento-bruto',
    label: 'Acab. Bruto',
    icone: 'AB',
    desc: 'Reboco, chapisco e contrapiso',
  },
  {
    id: 'acabamento-fino',
    label: 'Acab. Fino',
    icone: 'AF',
    desc: 'Revestimento, pintura e esquadrias',
  },
  { id: 'entrega', label: 'Entrega', icone: 'EN', desc: 'Limpeza, vistoria e habite-se' },
]

export const MODULO_TOTAL_TOPICOS: Record<string, number> = {
  terreno: 21,
  'sistemas-construtivos': 10,
  projetos: 17,
  'planejamento-financeiro': 13,
  'mao-de-obra': 11,
  execucao: 12,
  tributos: 23,
}

export const TOTAL_TOPICOS = Object.values(MODULO_TOTAL_TOPICOS).reduce((a, b) => a + b, 0)

export const ROUTES = {
  HOME: '/',
  PAINEL: '/painel',
  ONBOARDING: '/onboarding',
  MODULOS: '/modulos',
  MODULO_DETAIL: '/modulos/:moduloId',
  TOPICO_DETAIL: '/modulos/:moduloId/topicos/:topicoId',
  FINANCEIRO: '/financeiro',
  DOCUMENTOS: '/documentos',
  CHECKLIST: '/checklist',
  CHECKLIST_PENDENTES: '/checklist-pendentes',
  ALERTAS: '/alertas',
  CONFIG: '/config',
  DIARIO: '/diario',
  PENDENCIAS: '/pendencias',
  CALCULADORAS: '/calculadoras',
  CALCULADORA_DETAIL: '/calculadoras/:id',
  MATERIAIS: '/materiais',
  WIKI: '/wiki',
  WIKI_ARTICLE: '/wiki/:slug',
  ETAPA: '/etapa',
  CONTRATOS: '/contratos',
  CONTRATO_DETAIL: '/contratos/:id',
  CONTATOS: '/contatos',
  CRONOGRAMA: '/cronograma',
  DECISOES: '/decisoes',
  /** @deprecated Redireciona para ETAPA — mantido só para links antigos. */
  PASSO: '/passo',
  MAIS: '/mais',
} as const

export const contratoDetailPath = (id: number) => `/contratos/${id}`

/** Rotas cujo modo é inequívoco — usadas para sincronizar o toggle Guia/Obra ao navegar. */
export const OBRA_ROUTE_PREFIXES: readonly string[] = [
  ROUTES.PAINEL,
  ROUTES.FINANCEIRO,
  ROUTES.DOCUMENTOS,
  ROUTES.DIARIO,
  ROUTES.PENDENCIAS,
  ROUTES.MATERIAIS,
  ROUTES.CONTRATOS,
  ROUTES.CONTATOS,
  ROUTES.CRONOGRAMA,
  ROUTES.DECISOES,
]

export const GUIA_ROUTE_PREFIXES: readonly string[] = [
  ROUTES.MODULOS,
  ROUTES.ETAPA,
  ROUTES.CALCULADORAS,
  ROUTES.WIKI,
  ROUTES.CHECKLIST,
  ROUTES.CHECKLIST_PENDENTES,
]

export const CONTATO_PAPEIS: SelectOption[] = [
  { value: 'pedreiro', label: 'Pedreiro' },
  { value: 'empreiteiro', label: 'Empreiteiro' },
  { value: 'mestre-de-obras', label: 'Mestre de obras' },
  { value: 'eletricista', label: 'Eletricista' },
  { value: 'hidraulico', label: 'Encanador' },
  { value: 'pintor', label: 'Pintor' },
  { value: 'carpinteiro', label: 'Carpinteiro' },
  { value: 'engenheiro', label: 'Engenheiro' },
  { value: 'arquiteto', label: 'Arquiteto' },
  { value: 'fornecedor', label: 'Fornecedor' },
  { value: 'outro', label: 'Outro' },
]

export const CONTRATO_TIPOS: SelectOption[] = [
  { value: 'empreitada-global', label: 'Empreitada (preço fechado)' },
  { value: 'empreitada-medicao', label: 'Empreitada por medição' },
  { value: 'diaria', label: 'Diária' },
  { value: 'administracao', label: 'Administração' },
]

export const DIARIO_CLIMAS: SelectOption[] = [
  { value: 'sol', label: 'Sol' },
  { value: 'nublado', label: 'Nublado' },
  { value: 'chuva', label: 'Chuva' },
  { value: 'chuva-forte', label: 'Chuva forte' },
]

/** Sinal acima disso é o principal sinal de alerta em golpes de reforma. */
export const SINAL_MAXIMO_PCT = 30
export const RESERVA_CONTINGENCIA_PADRAO_PCT = 10

export const moduloDetailPath = (moduloId: string) => `/modulos/${moduloId}`
export const topicoDetailPath = (moduloId: string, topicoId: string) =>
  `/modulos/${moduloId}/topicos/${topicoId}`
export const calcDetailPath = (id: string) => `/calculadoras/${id}`
export const wikiArticlePath = (slug: string) => `/wiki/${slug}`

export type Route = (typeof ROUTES)[keyof typeof ROUTES]
